// Kept apart from networking/registration.ts so that runtime users (AuthWrapper) don't pull in the network stack.
export const SSO_PROVIDERS = ["google", "apple", "fobizz"] as const;
export type SsoProvider = (typeof SSO_PROVIDERS)[number];
